import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { AgreementService } from "@/services/AgreementService"
import { MeterpointService } from "@/services/MeterpointService"
import { MeterpointAgreements } from "@/types/MeterpointAgreements"

export const getAccountMeterpointAgreements = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  const meterpointsQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointsQuery)

  const agreements = meterpointsQuery.data.reduce(
    (meterpointAgreementsMap, meterpoint) => {
      const query = AgreementService.getForMeterpoint(
        coreIdQuery.data,
        meterpoint.identifier,
      )
      queries.add(query)

      meterpointAgreementsMap[meterpoint.identifier] = query.data
      return meterpointAgreementsMap
    },
    {} as MeterpointAgreements,
  )

  return queries.setData(agreements).getAggregate()
}
